<ng-container *ngIf="{premiumTransportOptionSelected: premiumTransportOptionSelected$ | async} as data">
  <div class="w-full flex justify-center mt-3">
    <div class="edit-appointment-dialog-container flex flex-col px-6 py-1.5 w-full max-w-3xl">
      <div class="flex flex-row pb-9 justify-between">
        <span class="text-base font-semibold" style="font-family: 'Open Sans';">
          Appointment Details
        </span>
        <div *ngIf="dialogData.initialAppointment.externalAppointmentUrl" class="flex flex-row space-x-4 items-center">
          <span class="text-sm font-normal">External Booking URL</span>
          <div class="cursor-pointer"
            (click)="openExternalBookingUrl(dialogData.initialAppointment.externalAppointmentUrl)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#0054A6"
              class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
            </svg>
          </div>
          <div class="cursor-pointer"
            (click)="copyExternalBookingUrl(dialogData.initialAppointment.externalAppointmentUrl)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#0054A6"
              class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
            </svg>
          </div>
        </div>
      </div>


      <form class="flex flex-col w-full space-y-1" [formGroup]=appointmentForm>

        <div class="flex flex-row space-x-6">
          <div class="flex flex-col w-56">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
              Date <sup>*</sup></span>
            <mat-form-field appearance="outline" class="text-sm">
              <input [matDatepicker]="appointmentPicker" id="dateTime" matInput formControlName="dateTime"
                [max]="maxDate" type="text" inputmode="numeric" (keydown)="validateDateFieldInput($event)">
              <mat-error *ngIf="formSubmitted && appointmentForm.get('dateTime').errors">
                {{appointmentForm.get('dateTime').errors | inputError}}
              </mat-error>
              <mat-datepicker-toggle matSuffix [for]="appointmentPicker"></mat-datepicker-toggle>
              <mat-datepicker #appointmentPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="flex flex-col w-1/3">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Drop
              Off <sup>*</sup></span>
            <mat-form-field appearance="outline" class="text-sm">
              <input id="appointmentTime" type="time" matInput formControlName="appointmentTime" (ngModelChange)="mapDateTimes('dateTime',
            $event)" onfocus="this.showPicker()">
              <mat-error *ngIf="formSubmitted && appointmentForm.get('appointmentTime').errors">
                {{appointmentForm.get('appointmentTime').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col w-1/3">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
              Service Code</span>
            <mat-form-field appearance="outline" class="text-sm">
              <mat-select
                (selectionChange)="serviceCodeSelected($event.value,dialogData.appointmentDropdowns.serviceCodes)"
                formControlName="serviceCode">
                <mat-option *ngFor="let sc of dialogData.appointmentDropdowns.serviceCodes" [value]="sc.serviceCode">
                  {{sc.serviceCode}} - {{sc.description}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="formSubmitted && appointmentForm.get('serviceCode').errors">
                {{appointmentForm.get('serviceCode').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row space-x-6">
          <div class="flex flex-col w-1/3">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Priority</span>
            <mat-form-field appearance="outline" class="text-sm">
              <input id="priorityNumber" matInput formControlName="priorityNumber" [value]="null"
                (keydown)="validateNumber($event)" type="text" inputmode="numeric" autocomplete="off">
            </mat-form-field>
          </div>

          <div class="flex flex-col w-1/3">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Tech/Tech
              Group</span>
            <mat-form-field appearance="outline" class="text-sm">
              <mat-select
                (selectionChange)="techOrGroupSelected($event,dialogData.appointmentDropdowns.technicians,dialogData.appointmentDropdowns.technicianGroups)"
                formControlName="techOrTechGroup">
                <mat-optgroup>
                  <label fxFlex class="w-full">
                    Tech Groups
                  </label>
                  <mat-option
                    *ngFor="let tg of dialogData.appointmentDropdowns.technicianGroups | filterBy: ['rooftopId']: dialogData.authenticatedEmployee.rooftopId | orderBy: 'description'"
                    [value]="tg.id">
                    {{tg.description}}
                  </mat-option>
                </mat-optgroup>
                <mat-optgroup>
                  <label fxFlex class="w-full">
                    Technicians
                  </label>
                  <mat-option
                    *ngFor="let tg of dialogData.appointmentDropdowns.technicians | filterBy: ['rooftopId']:  dialogData.authenticatedEmployee.rooftopId | sortNamesBy: ['lastName']"
                    [value]="tg.associateId">
                    {{tg.embedded.associate.lastName}}, {{tg.embedded.associate.firstName}}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex flex-col w-1/3">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Odometer
              <sup>*</sup></span>
            <mat-form-field appearance="outline" class="text-sm">
              <input id="odometerIn" matInput formControlName="odometerIn" [textMask]="{mask: numberMask, guide: false}"
                type="text" inputmode="numeric" autocomplete="off">
              <mat-error *ngIf="formSubmitted && appointmentForm.get('odometerIn').errors">
                {{appointmentForm.get('odometerIn').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row space-x-6">
          <div class="flex flex-col w-1/3">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
              Service Advisor <sup>*</sup>
            </span>
            <mat-form-field appearance="outline" class="text-sm">
              <mat-select formControlName="serviceAdvisorId">
                <mat-option
                  *ngFor="let advisor of dialogData.appointmentDropdowns.serviceAdvisors | filterBy: ['rooftopId']: dialogData.initialAppointment.rooftopId | sortNamesBy: ['lastName']"
                  [value]="advisor.embedded.associate.id">
                  {{advisor.embedded.associate.lastName ? advisor.embedded.associate.lastName :
                  ''}}{{advisor.embedded.associate.lastName && advisor.embedded.associate.firstName ? ', ' : ''}}
                  {{advisor.embedded.associate.firstName ? advisor.embedded.associate.firstName : ''}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="formSubmitted && appointmentForm.get('serviceAdvisorId').errors">
                {{appointmentForm.get('serviceAdvisorId').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col w-1/3">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
              Booking Employee
            </span>
            <mat-form-field appearance="outline" class="text-sm">
              <mat-select formControlName="employeeId">
                <mat-option
                  *ngFor="let advisor of dialogData.appointmentDropdowns.employees | filterBy: ['rooftopId']: dialogData.initialAppointment.rooftopId | sortNamesBy: ['lastName']"
                  [value]="advisor.embedded.associate.id">
                  {{advisor.embedded.associate.lastName ? advisor.embedded.associate.lastName :
                  ''}}{{advisor.embedded.associate.lastName && advisor.embedded.associate.firstName ? ', ' : ''}}
                  {{advisor.embedded.associate.firstName ? advisor.embedded.associate.firstName : ''}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex flex-col w-1/3">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Promised
              Time</span>
            <mat-form-field appearance="outline" class="text-sm">
              <input id="promisedDateTime" type="time" matInput formControlName="promisedTime" (ngModelChange)="mapDateTimes('promisedDateTime',
            $event)" onfocus="this.showPicker()">
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row space-x-6">
          <div class="flex flex-col w-1/3">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
              Transportation Option</span>
            <mat-form-field appearance="outline" class="text-sm">
              <mat-select formControlName="transportOptionId">
                <mat-option [value]="">None</mat-option>
                <mat-option
                  *ngFor="let transportOption of dialogData.appointmentDropdowns.transportOptions | orderBy: 'name'"
                  [value]="transportOption.id">
                  {{transportOption.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-row w-2/3 mt-2 h-full items-center justify-start">
            <div class="transform scale-90">
              <button type="button" (click)="addTransportDetailsToggle()"
                [disabled]="data.premiumTransportOptionSelected"
                [ngClass]="{'bg-quorum-blue': addTransportDetails, 'bg-grey-300': !addTransportDetails || data.premiumTransportOptionSelected }"
                class="relative inline-flex mt-0.5 h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out">
                <span [ngClass]="addTransportDetails ? 'translate-x-5 ':'translate-x-0'"
                  class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
              </button>
            </div>
            <span class="font-medium text-sm ml-2" style="font-family: 'Open Sans'; color: #282828">
              Add Transportation Details <sup *ngIf="data.premiumTransportOptionSelected">*</sup></span>
          </div>
        </div>
      </form>

      <div *ngIf="addTransportDetails">
        <span class="text-base font-semibold pt-4 pb-9 inline-block" style="font-family: 'Open Sans';">
          Add Transportation Details
        </span>

        <div class="flex flex-col w-full space-y-1">

          <span class="text-base font-medium pb-4 inline-block" style="font-family: 'Open Sans';">
            Drop Off Information
          </span>

          <form [formGroup]=transportationDetailsDropOffForm>
            <div class="flex flex-row space-x-6">
              <div class="flex flex-col w-1/3" *ngIf="!data.premiumTransportOptionSelected">
                <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                  Transportation Option <sup>*</sup></span>
                <mat-form-field appearance="outline" class="text-sm">
                  <mat-select formControlName="transportOptionId">
                    <mat-option [value]=""></mat-option>
                    <mat-option *ngFor="let transportOption of dialogData.appointmentDropdowns.transportOptions"
                      [value]="transportOption.id">
                      {{transportOption.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="formSubmitted && transportationDetailsDropOffForm.get('transportOptionId').errors">
                    {{transportationDetailsDropOffForm.get('transportOptionId').errors | inputError}}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col" [ngClass]="data.premiumTransportOptionSelected ? 'w-2/3' : 'w-1/3'">
                <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Address
                  <sup>*</sup></span>
                <mat-form-field appearance="outline" class="text-sm">
                  <input matInput formControlName="addressLine" [matAutocomplete]="autoDropOff">
                  <mat-autocomplete class="address-autocomplete-container" #autoDropOff="matAutocomplete">
                    <mat-option (click)="onDropOffAddressSelected(address)"
                      *ngFor="let address of addressSuggestionsDropOff$ | async"
                      [value]="trimCountry(address.description)">
                      {{ address.description }}
                    </mat-option>
                  </mat-autocomplete>
                  <button
                    [ngClass]="this.transportationDetailsDropOffForm.get('addressLine').value ? 'visible' : 'invisible'"
                    matSuffix (click)="clearAddressInput('DropOff')">
                    <mat-icon class="transform scale-75">close</mat-icon>
                  </button>
                  <mat-error *ngIf="formSubmitted && transportationDetailsDropOffForm.get('addressLine').errors">
                    {{transportationDetailsDropOffForm.get('addressLine').errors | inputError}}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col w-1/3">
                <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                  Phone Number <sup>*</sup></span>
                <mat-form-field appearance="outline" class="text-sm">
                  <input id="dropOffPhoneNumber" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
                    formControlName="phone" type="text" inputmode="numeric" autocomplete="off">
                  <mat-error *ngIf="formSubmitted && transportationDetailsDropOffForm.get('phone').errors">
                    {{transportationDetailsDropOffForm.get('phone').errors | inputError}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </form>

          <div class="flex flex-row space-x-6 pb-4 items-center">
            <span class="w-1/3 text-base font-medium inline-block" style="font-family: 'Open Sans';">
              Pick Up Information
            </span>

            <div class="flex flex-row w-2/3 h-full items-center justify-start">
              <div class="transform scale-90">
                <button type="button" (click)="sameAsDropOffToggle()"
                  [ngClass]="sameAsDropOff ? 'bg-quorum-blue':'bg-grey-300'"
                  class="relative inline-flex mt-0.5 h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out">
                  <span [ngClass]="sameAsDropOff ? 'translate-x-5 ':'translate-x-0'"
                    class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                </button>
              </div>
              <span class="font-medium text-sm ml-2" style="font-family: 'Open Sans'; color: #282828">
                Same as Drop Off</span>
            </div>
          </div>

          <form [formGroup]=transportationDetailsPickUpForm>
            <div class="flex flex-row space-x-6">
              <div class="flex flex-col w-1/3" *ngIf="!data.premiumTransportOptionSelected">
                <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                  Transportation Option <sup>*</sup></span>
                <mat-form-field appearance="outline" class="text-sm">
                  <mat-select formControlName="transportOptionId">
                    <mat-option [value]=""></mat-option>
                    <mat-option *ngFor="let transportOption of dialogData.appointmentDropdowns.transportOptions"
                      [value]="transportOption.id">
                      {{transportOption.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="formSubmitted && transportationDetailsPickUpForm.get('transportOptionId').errors">
                    {{transportationDetailsPickUpForm.get('transportOptionId').errors | inputError}}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col" [ngClass]="data.premiumTransportOptionSelected ? 'w-2/3' : 'w-1/3'">
                <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Address
                  <sup>*</sup></span>
                <mat-form-field appearance="outline" class="text-sm">
                  <input matInput formControlName="addressLine" [matAutocomplete]="autoPickUp">
                  <mat-autocomplete class="address-autocomplete-container" #autoPickUp="matAutocomplete">
                    <mat-option (click)="onPickUpAddressSelected(address)"
                      *ngFor="let address of addressSuggestionsPickUp$ | async"
                      [value]="trimCountry(address.description)">
                      {{ address.description }}
                    </mat-option>
                  </mat-autocomplete>
                  <button
                    [ngClass]="this.transportationDetailsPickUpForm.get('addressLine').value ? 'visible' : 'invisible'"
                    matSuffix (click)="clearAddressInput('PickUp')">
                    <mat-icon class="transform scale-75">close</mat-icon>
                  </button>
                  <mat-error *ngIf="formSubmitted && transportationDetailsPickUpForm.get('addressLine').errors">
                    {{transportationDetailsPickUpForm.get('addressLine').errors | inputError}}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col w-1/3">
                <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                  Phone Number <sup>*</sup></span>
                <mat-form-field appearance="outline" class="text-sm">
                  <input id="pickUpPhoneNumber" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
                    formControlName="phone" type="text" inputmode="numeric" autocomplete="off">
                  <mat-error *ngIf="formSubmitted && transportationDetailsPickUpForm.get('phone').errors">
                    {{transportationDetailsPickUpForm.get('phone').errors | inputError}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="w-full h-full bg-white mt-10">
        <div class="flex flex-row place-content-end items-center">
          <span (click)="cancel()" class="flex place-items-center place-content-center py-2.5 px-5 rounded-md"
            [ngStyle]="{ border: '1px solid #515251', cursor: 'pointer'}"
            style="font-family: 'Open Sans'; height: 34px">Cancel</span>
          <button (click)="save()" id="saveButton"
            class="flex place-items-center place-content-center py-2.5 px-5 rounded-md ml-3"
            [ngStyle]="{ background: 'rgba(0, 84, 166, 1)', cursor: 'pointer'}"
            style="font-family: 'Open Sans'; height: 34px" type="submit">
            <span class="text-white font-medium text-sm">Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>